module.exports = __webpack_public_path__ + "static/img/zhuajimajiang.bd747f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/zhuajimajiang.jpg
// module id = +k7N
// module chunks = 0